import { render, staticRenderFns } from "./ModalActionVm.vue?vue&type=template&id=ec3cd9e6&lang=html&"
import script from "./ModalActionVm.vue?vue&type=script&lang=js&"
export * from "./ModalActionVm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports